import {
  KalturaOTTUserDynamicData,
  KalturaStringValue,
  OttUserUpdateDynamicDataAction,
} from '@kaltura-ott/ott-client-types/api/types';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DynamicDataTypeEnum } from '../interfaces';

import { kalturaClient } from './kaltura-clent';

export interface DynamicData {
  key: DynamicDataTypeEnum;
  value: string;
}

export const updateDynamicData = ({ key, value }: DynamicData): Observable<KalturaOTTUserDynamicData> => {
  const client = kalturaClient();
  const action = new OttUserUpdateDynamicDataAction({
    key,
    value: new KalturaStringValue({ value }),
  });

  return client.request(action).pipe(
    catchError((error) => {
      return throwError(error);
    }),
  );
};
